import * as types from '../types/siteTypes';

const initialState = {
  items: [],
  topSites: [],
  categories: [],
  site: null,
  similarList: [],
  reviews: [],
  sponsored: [],
  pagination: { page: 1, limit: 20, total: 0 },
  reviewsPagination: { page: 1, limit: 20, total: 0 },
  loading: false,
  error: null,
};

const siteReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SITES_REQUEST:
    case types.FETCH_TOP_SITES_REQUEST:
    case types.FETCH_CATEGORIES_REQUEST:
    case types.FETCH_SIMILAR_REQUEST:
      return { ...state, loading: true, similarList: [], error: null };
    case types.FETCH_SIMILAR_SUCCESS:
      return { ...state, loading: false, similarList: action.payload || [], error: null };
    case types.FETCH_SIMILAR_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.FETCH_SITE_REQUEST:
      return { ...state, loading: true, similarList: [], error: null };
    case types.FETCH_REVIEWS_REQUEST:
    case types.FETCH_SPONSORED_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_SITES_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };

    case types.FETCH_TOP_SITES_SUCCESS:
      return { ...state, loading: false, topSites: action.payload || [], error: null };

    case types.FETCH_CATEGORIES_SUCCESS:
      return { ...state, loading: false, categories: action.payload || [], error: null };

    case types.FETCH_SITE_SUCCESS:
      return {
        ...state,
        loading: false,
        site: action.payload || null,
        error: null,
      };

    case types.FETCH_REVIEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        reviews: action.payload.data || [],
        reviewsPagination: action.payload.pagination || state.reviewsPagination,
        error: null,
      };

    case types.FETCH_SPONSORED_SUCCESS:
      return { ...state, loading: false, sponsored: action.payload || [], error: null };

    case types.FETCH_SITES_FAILURE:
    case types.FETCH_TOP_SITES_FAILURE:
    case types.FETCH_CATEGORIES_FAILURE:
    case types.FETCH_SITE_FAILURE:
    case types.FETCH_REVIEWS_FAILURE:
    case types.FETCH_SPONSORED_FAILURE:
    case types.FETCH_SIMILAR_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.CLEAR_SITE_STATE:
      return { ...initialState, categories: state.categories, topSites: state.topSites, similarList: [] };

    default:
      return state;
  }
};

export default siteReducer;

